import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IBaseBusinessManageRepository } from '@/coreInfrastructureModule/interfaces/IBaseBusinessManageRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

/**
 * 売り上げ先名を取得するユースケース
 * @param customer - 売り上げ先情報
 */
export class GetCustomerNameUseCase {
  private repository: IBaseBusinessManageRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IBaseBusinessManageRepository) {
    this.repository = repository;
  }
  /**
   * 売り上げ先名を取得する
   * @param customerNumber - 売り上げ先番号
   */
  async execute(customerNumber: string): Promise<INetworkResult<string | undefined, IError>> {
    try {
      const result = await this.repository.getCustomerName(customerNumber);
      return result;
    } catch (error) {
      console.error(error);
      return {
        status: {
          type: 'error',
          error: {
            message: '想定外のエラーが発生しました',
            statusCode: 0,
            code: '',
          },
        },
      };
    }
  }
}
